// src/com/login/MaskDsc.js
import React, { useEffect } from 'react';
import { styled  } from '@mui/material/styles';
import { Box, display } from '@mui/system';
import { Button, Grid2 } from '@mui/material';
import HomeWorkIcon from '@mui/icons-material/HomeWork'; // Mark my center.
import KeyIcon from '@mui/icons-material/Key'; // 전환.
import KeyOffIcon from '@mui/icons-material/KeyOff'; // 해제.
import CloseIcon from '@mui/icons-material/Close';
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { AppObject, AppStyle, AppWord } from '../../value/AppConst';
import { dcInfoListRepo, userInfoRepo } from '../../value/AppModel';
import { LIST_DC_INFO } from '../dc_info/DcInfoGql';
import { useAlertSetter } from '../../api/app-hook';
import { TopContainer, TopContent, TopHeader } from '../../common/TopStyle';


const DcName = styled(Box)({
    flexGrow: 1, fontSize: '0.9rem', textAlign: 'left'
});
const DcCode = styled('span')({
    fontSize: '0.75rem', color: '#888'
});

const ButtonBox = styled(Box)({
    display: 'flex', justifyContent: 'end'
});

/**
 * MaskDsc. 센터 전환을 위한 View.
 * 처리는 onRequestMask를 호출하여 상위 컴포넌트에서 처리한다.
 * @param {*} param0 
 */
export default function MaskDsc({
    onClose,
    onRequestMask, // (dcInfoItem) => {}
}) {
    const sessionInfo = useReactiveVar(userInfoRepo);
    const dcInfoListData = useReactiveVar(dcInfoListRepo);
    const addAlert = useAlertSetter();

    // ##### Call GraphQL to get List #####
    const [getDcInfoList, responseDcList] = useLazyQuery(LIST_DC_INFO, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetDcList(data, option)},
		onError: (error) => addAlert({title: '출발지 목록 조회 오류', message: [error.message]})
    });

    useEffect(()=>{
            const diff = new Date().getTime()/1000 - dcInfoListData.when;
            if(diff > 1200) getDcInfoList();
    }, [dcInfoListData]);

    // >>>>>>>>> callbacks <<<<<<<<<<<<<
    const onCompleteGetDcList = (data, clientOption) => {
        if(data.dcInfoList) {
            dcInfoListRepo({when:new Date().getTime()/1000, records:data.dcInfoList});
        }
    };

    const onClickMask = (dcInfoItem) => {
        if(sessionInfo.user.allDcYn === 'Y') onRequestMask(dcInfoItem);
    };

    /**
     * 전환 해제 버튼 클릭.
     * 자신의 센터 정보를 사용하여 전환을 해제한다.
     */
    const onClickUnmask = () => {
        onRequestMask(); // 전환 해제.
    };

    return(
        <TopContainer>
            <TopHeader>
                <span style={{flexGrow:1}}>물류센터 전환</span>
                <Button onClick={onClose}
                    startIcon={<CloseIcon />}
                >
                    닫기
                </Button>
            </TopHeader>
            <TopContent>
                {
                    responseDcList.loading ?
                    <Box style={{textAlign:'center', padding: '1rem', color: '#9df'}}>
                        잠시만 기다려 주세요.
                    </Box>
                    :
                    <Grid2 container spacing={1}>
                        {
                            dcInfoListData.records.map((dcInfoItem) => {
                                return(
                                    <Grid2 item size={6} key={dcInfoItem.dcCd}
                                        style={{
                                            display:'flex', alignItems:'center', paddingBottom: '0.3rem',
                                        }}>
                                        <DcName>
                                            <DcCode>[{dcInfoItem.dcCd}]</DcCode>
                                            {dcInfoItem.dcName}
                                        </DcName>
                                        <ButtonBox>
                                            {
                                                sessionInfo.user.dscId === dcInfoItem.dcCd
                                                ?
                                                <HomeWorkIcon style={{color:AppStyle.HomeplusRed}}/>
                                                :
                                                sessionInfo.user.dscIdAs === dcInfoItem.dcCd
                                                ?
                                                <Button
                                                    variant={AppStyle.mui.contained}
                                                    color={AppStyle.mui.secondary}
                                                    startIcon={<KeyOffIcon />}
                                                    onClick={() => onClickUnmask()}
                                                    size={AppWord.SMALL}
                                                >
                                                    해제
                                                </Button>
                                                :
                                                <Button
                                                    variant={AppStyle.mui.contained}
                                                    color={AppStyle.mui.inherit}
                                                    startIcon={<KeyIcon />}
                                                    onClick={() => onClickMask(dcInfoItem)}
                                                    size={AppWord.SMALL}
                                                >
                                                    전환
                                                </Button>
                                            }
                                        </ButtonBox>
                                    </Grid2>
                                )
                            })
                        }
                    </Grid2>
                }
            </TopContent>
        </TopContainer>
    );
}